import { css } from 'astroturf';
import React, { useState, useEffect } from 'react';

import UAParser from 'ua-parser-js';

import Brow from './Brow';

import chrome from '../../assets/images/browsers/chrome.png';
import firefox from '../../assets/images/browsers/firefox.png';
import safari from '../../assets/images/browsers/safari.png';
import edge from '../../assets/images/browsers/edge.png';
import PolypaneIcon from '../../assets/images/icon.svg';

const styles = css`
  .compare {
    text-align: center;
    trigger-scope: --compare-icon-drop;

    & h2 {
      text-align: center;
      font-weight: 900;
      font-size: clamp(18px, 16px + 4vw, 44px);
      letter-spacing: -0.015em;
      line-height: 1.2;
      margin: auto;
      margin-bottom: 1rem;
      margin-top: 0;
      max-width: 60rem;
      color: #0a1530;
    }

    @media (max-width: 480px) {
      & > svg {
        height: 40px;
      }
    }

    & > p {
      font-size: calc(16px + 0.25vw);
      font-weight: 400;
      position: relative;
      max-width: 52rem;
      margin: 0 auto 4rem;
      line-height: 1.75;
      @media (min-width: 770px) {
        font-size: 1.17rem;
      }
    }
  }

  .emoji {
    display: inline-flex;
    position: relative;

    img,
    svg {
      width: 4rem;
      height: 4rem;
      color: #398aa4;
      filter: saturate(0.5);
    }
  }

  .blockWrap:nth-last-child(1) {
    .emoji svg {
      color: rgb(103, 178, 111);
      filter: saturate(1);
    }
  }

  .item {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
  }

  .itemIcon {
    line-height: 1;
    flex-shrink: 0;
    margin-top: 0;

    svg {
      width: 1.75rem;
      height: 1.75rem;
      color: rgb(103, 178, 111);
    }
  }
  .beforeItem .itemIcon {
    margin-top: 0.125rem;
    svg {
      width: 1.5rem;
      height: 1.5rem;
      filter: saturate(0);
    }
  }

  .itemContent {
    flex: 1;
  }

  .itemTitle {
    font-size: 1.125em;
    font-weight: 600;
    margin: 0 0 0.5rem 0;
    color: rgb(10, 21, 48);
    line-height: 1.3;
  }

  .itemDescription {
    font-size: 1rem;
    margin: 0;
    color: #0009;
    line-height: 1.5;
    text-wrap: balance;
  }

  .afterItem .itemTitle {
    font-size: 1.375em;
    font-weight: 700;
    margin-bottom: 0.25rem;
  }

  .compareHeaders {
    text-align: left;
    display: flex;
    justify-content: space-around;

    flex-direction: column;
    align-items: center;
    max-width: 1100px;
    margin: 2rem auto;
    padding: 0 2rem;
    gap: 1rem 2rem;

    .blockWrap {
      flex: 0 0 auto;

      display: flex;
      justify-content: flex-start;
    }

    > svg {
      color: #398aa4;
      transform: rotate(90deg) scale(0.6);
    }

    .block {
      display: flex;
      align-items: center;
      gap: 1rem;
      margin: 0 auto;
      padding: 0;

      div {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
      h3 {
        font-size: 1.25rem;
        font-weight: 700;
        margin: 0;
        color: rgb(10, 21, 48);
        padding: 0;
        line-height: 1;
      }
      p {
        color: #0009;
        font-size: 1rem;
        line-height: 1;
        margin: 0;
      }
    }

    @media (min-width: 800px) {
      flex-direction: row;
      justify-content: flex-start;
      gap: 0 calc(75px + 4rem);
      .blockWrap {
        flex: 1 1 300px;
      }

      .block {
        white-space: nowrap;
      }

      > svg {
        display: none;
      }
    }
  }

  .compareBlocks {
    text-align: left;
    max-width: 1100px;
    margin: 0 auto 10rem;
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
    padding: 0 1rem;

    hr {
      width: 75%;
      margin: 0 auto;
      height: 1px;
      border: 0;
      background: rgba(156, 163, 175, 0.1);
    }
  }

  .comparison {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: stretch;
    max-width: 1100px;
    margin: 0;
    padding: 1rem;
    position: relative;
    gap: 0 2rem;
    min-height: 118px;
    border-radius: 10px;
    box-shadow:
      rgba(0, 0, 0, 0.024) 0px 0px 0px 1px,
      rgba(0, 0, 0, 0.05) 0px 1px 0px,
      rgba(0, 0, 0, 0.03) 0px 0px 8px,
      rgba(0, 0, 0, 0.1) 0px 20px 30px;
    background: linear-gradient(
      to bottom,
      #fee 0%,
      #fee calc(50% - 200px),
      #fff 50%,
      #efe calc(50% + 200px),
      #efe 100%
    );

    .item {
      flex: 1 1 40%;
    }

    .arrow {
      align-self: center;
      flex: 0 0 48px;
      text-align: center;
      margin: 0 1rem;
      transform: rotate(90deg) scale(0.6);
      color: #398aa4;
    }

    &:nth-child(1),
    &:nth-child(5),
    &:nth-child(9) {
      .arrow {
        transform: rotate(90deg) scale(0.6) scaleY(-1);
      }
    }

    @media (min-width: 800px) {
      flex-direction: row;
      justify-content: center;
      padding: 0.5rem 2rem;

      background: linear-gradient(
        to right,
        #fee 0%,
        #fee 3rem,
        #fff calc(20%),
        #fff calc(80%),
        #efe calc(100% - 3rem),
        #efe 100%
      );
      .item {
        padding: 1rem 0rem;
        max-width: 460px;
      }
      .arrow {
        transform: rotate(0deg) scale(1);
      }
      &:nth-child(1),
      &:nth-child(5),
      &:nth-child(9) {
        .arrow {
          transform: scaleY(-1);
        }
      }
    }
  }
`;

const Icon = ({ browser }) => {
  switch (browser) {
    case 'Chrome':
      return <img src={chrome} alt="Chrome logo" />;
    case 'Firefox':
      return <img src={firefox} alt="Firefox logo" />;
    case 'Safari':
    case 'Mobile Safari':
      return <img src={safari} alt="Safari logo" />;
    case 'Edge':
      return <img src={edge} alt="Edge logo" />;
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-device-desktop"
        >
          <path d="M3 5a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10z" />
          <path d="M7 20h10" />
          <path d="M9 16v4" />
          <path d="M15 16v4" />
        </svg>
      );
  }
};

function Compare(props) {
  const [browser, setBrowser] = useState('Chrome, Firefox or Safari');

  useEffect(() => {
    const parser = new UAParser();
    const result = parser.getResult();
    const browserName = result.browser.name || 'Chrome, Firefox or Safari';
    setBrowser(browserName);
  }, []);

  return (
    <div className={styles.compare}>
      <Brow>Beyond Chrome, Firefox and Safari</Brow>
      <h2>Why developers choose Polypane over {browser}</h2>

      <p>
        Polypane replaces your patchwork of tools with a single, powerful browser designed for building better websites.
        Once you try it, you'll never want to go back.
      </p>

      <div className={styles.compareHeaders}>
        <div className={styles.blockWrap}>
          <div className={styles.block}>
            <span className={styles.emoji}>
              <Icon browser={browser} />
            </span>
            <div>
              <h3>With {browser}</h3>
              <p>Frustration. Inefficiency. Blind spots.</p>
            </div>
          </div>
        </div>
        <Arrow />
        <div className={styles.blockWrap}>
          <div className={styles.block}>
            <span className={styles.emoji}>
              <PolypaneIcon />
            </span>
            <div>
              <h3>With Polypane</h3>
              <p>Clarity. Speed. Confidence.</p>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.compareBlockWrapper}>
        <div className={styles.compareBlocks}>
          <div className={styles.comparison}>
            <div className={`${styles.item} ${styles.beforeItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-puzzle"
                >
                  <path d="M4 7h3a1 1 0 0 0 1 -1v-1a2 2 0 0 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-1a1 1 0 0 0 -1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 0 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 0 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Switching between breakpoints manually</h4>
                <p className={styles.itemDescription}>Constantly resizing your window or dragging dev tools around.</p>
              </div>
            </div>

            <div className={styles.arrow}>
              <Arrow />
            </div>

            <div className={`${styles.item} ${styles.afterItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-photo"
                >
                  <path d="M15 8h.01" />
                  <path d="M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z" />
                  <path d="M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5" />
                  <path d="M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Multiple synchronized viewports</h4>
                <p className={styles.itemDescription}>
                  See and interact with all breakpoints at once. Build once, preview everywhere.
                </p>
              </div>
            </div>
          </div>

          <hr />

          <div className={styles.comparison}>
            <div className={`${styles.item} ${styles.beforeItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-hourglass"
                >
                  <path d="M6.5 7h11" />
                  <path d="M6.5 17h11" />
                  <path d="M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z" />
                  <path d="M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Slow testing workflow</h4>
                <p className={styles.itemDescription}>One screen, one viewport, one change at a time.</p>
              </div>
            </div>

            <div className={styles.arrow}>
              <Arrow />
            </div>

            <div className={`${styles.item} ${styles.afterItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-bolt"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Faster iterations</h4>
                <p className={styles.itemDescription}>Edit code → changes live across all devices instantly.</p>
              </div>
            </div>
          </div>
          <hr />
          <div className={styles.comparison}>
            <div className={`${styles.item} ${styles.beforeItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-mood-sad-dizzy"
                >
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                  <path d="M14.5 16.05a3.5 3.5 0 0 0 -5 0" />
                  <path d="M8 9l2 2" />
                  <path d="M10 9l-2 2" />
                  <path d="M14 9l2 2" />
                  <path d="M16 9l-2 2" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Missing accessibility issues</h4>
                <p className={styles.itemDescription}>
                  Limited or no built-in accessibility checks. Manual testing with patchwork extensions. Ship
                  inaccessible code anyway.
                </p>
              </div>
            </div>
            <div className={styles.arrow}>
              <Arrow />
            </div>

            <div className={`${styles.item} ${styles.afterItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-disabled-2"
                >
                  <path d="M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                  <path d="M9 11a5 5 0 1 0 3.95 7.95" />
                  <path d="M19 20l-4 -5h-4l3 -5l-4 -3l-4 1" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Built-in accessibility auditing</h4>
                <p className={styles.itemDescription}>
                  Instant contrast checks, focus order overview, accessibility features emulation, and more.
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className={styles.comparison}>
            <div className={`${styles.item} ${styles.beforeItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-target"
                >
                  <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                  <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Guessing about UX across devices</h4>
                <p className={styles.itemDescription}>
                  What your site actually looks like on mobile is a mystery until you test each one individually.
                </p>
              </div>
            </div>

            <div className={styles.arrow}>
              <Arrow />
            </div>

            <div className={`${styles.item} ${styles.afterItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-devices"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-10z" />
                  <path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9" />
                  <path d="M16 9h2" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Device realism</h4>
                <p className={styles.itemDescription}>
                  Pre-configured panes that match real device resolutions and behaviors.
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className={styles.comparison}>
            <div className={`${styles.item} ${styles.beforeItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-search"
                >
                  <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                  <path d="M21 21l-6 -6" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Over-reliance on extensions</h4>
                <p className={styles.itemDescription}>
                  Cramming 10+ dev tools into {browser} and still missing insights.
                </p>
              </div>
            </div>

            <div className={styles.arrow}>
              <Arrow />
            </div>

            <div className={`${styles.item} ${styles.afterItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-brain"
                >
                  <path d="M15.5 13a3.5 3.5 0 0 0 -3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8" />
                  <path d="M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1 -7 0v-1.8" />
                  <path d="M17.5 16a3.5 3.5 0 0 0 0 -7h-.5" />
                  <path d="M19 9.3v-2.8a3.5 3.5 0 0 0 -7 0" />
                  <path d="M6.5 16a3.5 3.5 0 0 1 0 -7h.5" />
                  <path d="M5 9.3v-2.8a3.5 3.5 0 0 1 7 0v10" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>All-in-one power tools</h4>
                <p className={styles.itemDescription}>
                  Meta previews, live reloading, image overlays, design &amp; dev tools in one clean interface.
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className={styles.comparison}>
            <div className={`${styles.item} ${styles.beforeItem}`}>
              <span className={styles.itemIcon} aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-test-pipe"
                >
                  <path d="M20 8.04l-12.122 12.124a2.857 2.857 0 1 1 -4.041 -4.04l12.122 -12.124" />
                  <path d="M7 13h8" />
                  <path d="M19 15l1.5 1.6a2 2 0 1 1 -3 0l1.5 -1.6z" />
                  <path d="M15 3l6 6" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Inconsistent testing environments</h4>
                <p className={styles.itemDescription}>
                  You test on your screen. Designer tests on theirs. QA tests on something else. "Works on my machine"
                  but everyone sees something else.
                </p>
              </div>
            </div>

            <div className={styles.arrow}>
              <Arrow />
            </div>

            <div className={`${styles.item} ${styles.afterItem}`}>
              <span className={styles.itemIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-wall"
                >
                  <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
                  <path d="M4 8h16" />
                  <path d="M20 12h-16" />
                  <path d="M4 16h16" />
                  <path d="M9 4v4" />
                  <path d="M14 8v4" />
                  <path d="M8 12v4" />
                  <path d="M16 12v4" />
                  <path d="M11 16v4" />
                </svg>
              </span>
              <div className={styles.itemContent}>
                <h4 className={styles.itemTitle}>Unified testing experience</h4>
                <p className={styles.itemDescription}>
                  You all see the same thing: every pane, every breakpoint, every audit. Everyone's on the same page.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Compare;

const Arrow = () => (
  <svg width="70" height="51" viewBox="0 0 132 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.70074 27.2342C41.5628 40.8992 77.6664 38.8765 129.591 24.3347M118.112 19.9279C125.647 22.5428 129.591 24.3347 129.591 24.3347M129.591 24.3347C129.591 24.3347 122.329 33.5367 118.335 31.3398"
      stroke="currentColor"
      strokeWidth="4"
    />
  </svg>
);
